<template>
    <be-form-group v-bind="widgetProps">
        <label :class="computedLabelClass(option)" v-for="option in options" :key="option.value">
            <input
                ref="el"
                :class="inputClass"
                :type="multiple ? 'checkbox' : 'radio'"
                :name="name"
                :value="option.value"
                :required="required"
                :disabled="disabled"
                :checked="isChecked(option)"
                @input="submit"
                @change="submit"
            >
            <span class="custom-control-label">
                <i :class="`mdi mdi-${option.icon}`" v-if="option.icon"></i>
                <template v-else>{{ option.label }}</template>
            </span>
        </label>
        <template slot="description"><slot name="description"/></template>
        <template slot="after"><slot/></template>
    </be-form-group>
</template>

<script>
    import widget from '../../mixins/widget';
    import BeFormGroup from '../theme/BeFormGroup';

    export default {
        mixins: [widget],
        components: { BeFormGroup },

        props: {
            name: {
                type: String,
                required: true,
            },
            options: {
                type: Array,
                required: true,
            },
            inline: {
                type: Boolean,
                required: false,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            isChecked: vm => option => (
                vm.value instanceof Array ? vm.value.includes(option.value) : vm.value === option.value
            ),

            computedLabelClass: vm => option => ({
                'custom-control': true,
                'custom-control-inline': vm.inline,
                'custom-checkbox': vm.multiple,
                'custom-radio': !vm.multiple,
                'custom-radio-icon': option.icon,
            }),

            inputClass: vm => ({
                'custom-control-input': true,
                'is-invalid': vm.validation && vm.validation.$error,
            }),
        },

        methods: {
            computeValue() {
                const values = [];
                let i;
                let inputs = this.$refs.el;

                if (!(inputs instanceof Array)) {
                    inputs = [inputs];
                }

                for (i = 0; i < inputs.length; i += 1) {
                    if (inputs[i].checked) {
                        if (!this.multiple) {
                            return inputs[i].value;
                        }

                        values.push(inputs[i].value);
                    }
                }

                return values;
            },

            submit() {
                this.$emit('input', this.computeValue());
            },
        },
    };
</script>
